/**
 * @file contact.service.ts
 * @path apps/website/src/features/contact/contact.service.ts
 */
import { faqs } from "@/data/faqs";
import { FaqItem } from "@sirbastians/types";
import { ContactFormData } from "./contact.types";
import { httpsCallable } from "firebase/functions";
import functions from "@/config/firebase.config";

export class ContactService {
  /**
   * Simulates sending a contact message to an API.
   * Replace this with your actual fetch/axios call.
   */
  static async sendMessage(data: ContactFormData): Promise<void> {
    const submitContactForm = httpsCallable(functions, "submitContactForm");
    await submitContactForm(data);
  }

  /**
   * Retrieves FAQ data.
   */
  static getFaqs(): FaqItem[] {
    return faqs;
  }
}
